/****************************************************
 * Module Name:  mixSalesProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class MixSaleProxy {
  static GetAllSale = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/sale",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllSaleByDate = (bucket, fromDate, toDate, callback) => {
    restAPICall(
      Constants.MANAGER_URL +
      `/mix/sale/${bucket}/${fromDate}/${toDate}/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllReportSaleByDate = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/mix/sale/query`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static PayMixInvoiceAmount = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/mix/amounttopaid`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleSale = (saleId, callback) => {
    let params = {
      id: saleId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/mix/sale",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static MixSellInvoice = (sale, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stone/bucket/mixsell",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(sale),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => callback(undefined));
  };

  static MixSellProforma = (sale, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stone/bucket/mixsell/proforma",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(sale),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => callback(undefined));
  };

  static GetAllInvoiceReport = (data, type, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/report/mixinvoice/${type}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllProformaOpen = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/report/mixproforma/customer/open`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllProformaReport = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/report/mixproforma/customer`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteProforma = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/stone/bucket/mixproforma`,
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetCustomersCreatedInvoice = (locationid, userid, usertype, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/mix/invoice/customers/${locationid}/${userid}/${usertype}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetCustomersCreatedProforma = (locationid, userid, usertype, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/mix/proforma/customers/${locationid}/${userid}/${usertype}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllMixInvoiceReport = (userid, userType, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/mix/invoice/${userid}/${userType}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllMixProformaReport = (userid, userType, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/mix/proforma/${userid}/${userType}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllMixCustomerWisePendingPayment = (userid, usertype, callback) => {
    let params = {
      userid: userid,
      usertype: usertype
    }
    restAPICall(
      Constants.MANAGER_URL + `/report/mixcustomer/pendingamount`,
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetDayWiseMixBucketSales = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/report/daywise/mixbucketsales`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetCancelledMixBucket = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/report/cancelledmixbucket",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

}
